import React from "react";
import { ChipProps } from "@mui/material";

import { AdminChip, ExternalChip, GuestChip, MemberChip } from "./AccountBox.styles";

interface AccountTypeChipProps extends Omit<ChipProps, "label"> {
  external: boolean;
  role?: string;
}

const AccountTypeChip: React.FC<AccountTypeChipProps> = ({ external, role, size = "small", ...chipProps }) => {
  if (external) {
    return <ExternalChip label="External" data-testid="external-chip" size={size} {...chipProps} />;
  }
  if (role === "admin") {
    return <AdminChip label="Admin" data-testid="admin-chip" size={size} {...chipProps} />;
  }
  if (role === "guest") {
    return <GuestChip label="Guest" data-testid="guest-chip" size={size} {...chipProps} />;
  }
  return <MemberChip label="Member" data-testid="member-chip" size={size} {...chipProps} />;
};

export default AccountTypeChip;
